import { Component } from '@angular/core';
import { ActionIconsComponent } from '../../../components/action-icons/action-icons.component';
import { ValueAnalysisComponent as SharedValueAnalysisComponent } from '../../../components/value-analysis/value-analysis.component';

@Component({
  selector: 'app-space-value-analysis-page',
  standalone: true,
  imports: [SharedValueAnalysisComponent, ActionIconsComponent],
  templateUrl: './value-analysis.component.html',
  styleUrl: './value-analysis.component.scss'
})
export class SpaceValueAnalysisComponent {}
